import React, { Component } from 'react';
import LandscapesView from './LandscapesView';
import { connect } from 'react-redux';
import * as tripActions from '../../../actions/tripActions';

class LandscapesContainer extends Component {
  changeStep = (step, values) => {
    const { changeCurrentStep, saveTripData, persistTripData, editTrip, id } = this.props;
    changeCurrentStep(step);
    saveTripData(values);
  };

  render() {
    return <LandscapesView {...this.props} changeStep={this.changeStep} state={this.state} />;
  }
}

function mapStateToProps(state) {
  return {
    id: state.tripReducer.tripForm.id,
    landscapes: state.tripReducer.tripForm.landscapes,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    changeCurrentStep: step => dispatch(tripActions.changeCurrentStep(step)),
    saveTripData: data => dispatch(tripActions.saveTripData(data)),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(LandscapesContainer);
